'use strict'

export function updateRecords (costRecords, sortDesc) {
  if (costRecords.length > 1) {
    costRecords.sort((r1, r2) => compareFromDate(r1.fromDate, r2.fromDate, sortDesc))

    let prevCostRecord = null
    for (const costRecord of costRecords) {
      if (prevCostRecord != null) {
        prevCostRecord.toDate = costRecord.fromDate
      }
      prevCostRecord = costRecord
    }
  }
}

function compareFromDate (v1, v2, sortDesc) {
  let compare = 0
  if (v1 == null && v2 != null) {
    compare = -1
  } else if (v1 != null && v2 == null) {
    compare = 1
  } else if (v1 != null) {
    compare = (v1 === v2) ? 0 : v1 > v2 ? 1 : -1
  }
  if (compare != 0 && sortDesc) {
    compare = -compare
  }
  return compare
}
